module.exports = __webpack_public_path__ + "img/2356505.ad433f2e.png";